import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const CanadaPostRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.canadaPost"
        components={{
          mail: (
            <a
              href={`mailto:Ivan.Blasco@canadapost.postescanada.ca`}
              className="email_space"
            >
              Ivan.Blasco@canadapost.postescanada.ca
            </a>
          ),
        }}
      />
    </div>
  );
};

export default CanadaPostRequirements;
